
import LedSearchFormLicencePlate from '@/components/LedSearchFormLicencePlate.vue'
import LedSearchFormVehicles from '@/components/LedSearchFormVehicles.vue'
export default {
  name: 'LedSearchForm',
  components: {
    LedSearchFormVehicles,
    LedSearchFormLicencePlate,
  },
  data() {
    return {
      highlightSearch: false,
    }
  },
  methods: {
    handleCloseModal() {
      this.$emit('closeModal')
    },
    handleVehicleSelected(vehicle) {
      this.$store.dispatch('setSelectedVehicle', vehicle)
      this.$store.dispatch('addToVehicleSearchHistory', vehicle)
    },
    highlightVehicleSearch() {
      // Attendre que la modal se ferme (délai pour l'animation de fermeture)
      setTimeout(() => {
        this.highlightSearch = true

        // Scroll vers le formulaire de recherche
        this.$nextTick(() => {
          if (this.$refs.vehicleSearchForm) {
            this.$refs.vehicleSearchForm.scrollIntoView({
              behavior: 'smooth',
              block: 'center',
            })
          }
        })

        // Retirer le highlight après 3 secondes
        setTimeout(() => {
          this.highlightSearch = false
        }, 3000)
      }, 500)
    },
  },
}
